import { TICKER_ITEMS } from "../data/sampleData";

/* One slow, muted editorial strip — serif type, brass diamonds between items. */
export const Ticker = () => {
    const Row = ({ hidden = false }) => (
        <span
            aria-hidden={hidden || undefined}
            className="flex shrink-0 items-center"
        >
            {TICKER_ITEMS.map((item, i) => (
                <span key={i} className="flex items-center">
                    <span className="whitespace-nowrap px-8 font-display text-sm italic text-ink-muted sm:text-base">
                        {item}
                    </span>
                    <span className="inline-block h-1.5 w-1.5 rotate-45 bg-brass/70" />
                </span>
            ))}
        </span>
    );

    return (
        <div
            className="overflow-hidden border-y border-line py-4"
            data-testid="ticker"
        >
            <div className="animate-marquee flex w-max">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
};
